import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './services/router'
import store from './services/store.js'
import BootstrapVue from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus, faMinus, faTimes, faSearch, faExclamationTriangle, faSpinner, faFileAlt, faQrcode, faAddressCard, faExclamationCircle, faFilter, faRedo, faBellSlash, faCreditCard, faCommentSms, faUserDoctor, faLocationDot, faNotesMedical, faCaretUp, faCaretDown, faHospitalUser } from '@fortawesome/free-solid-svg-icons'
import { faUserCircle, faTimesCircle, faEdit, faTrashAlt, faCircle, faCheckCircle } from '@fortawesome/free-regular-svg-icons'
import { faHandHoldingMedical, faPrescriptionBottle, faAllergies, faScalpelPath, faMortarPestle, faBooksMedical, faVideoSlash, faMicrophoneAlt, faMicrophoneAltSlash, faPortrait, faExternalLink, faLaptopMedical, faSlash, faNote, faPen } from '@fortawesome/pro-light-svg-icons'
import { faSms, faCheck, faMoneyCheckAlt, faClipboardMedical, faFileInvoiceDollar, faMessageDollar, faBuildingColumns, faX, faHospital, faCheckDouble, faSquareArrowUpRight, faListUl, faCircleInfo, faBarsProgress, faChartNetwork, faShieldCheck, faUpload, faBoxArchive, faCalendarCircleUser, faFileUpload, faFolderArrowDown, faCreditCardFront, faVideo, faEnvelope, faTabletAlt, faMoneyCheckDollar, faClipboardListCheck } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import * as vClickOutside from 'v-click-outside-x'
import VueLogger from 'vuejs-logger'
import VueMatomo from 'vue-matomo'
const isProduction = process.env.VUE_APP_ENVIRONMENT === 'production'

library.add(faPlus)
library.add(faRedo)
library.add(faX)
library.add(faMinus)
library.add(faUserCircle)
library.add(faCheck)
library.add(faTimes)
library.add(faSearch)
library.add(faEdit)
library.add(faTrashAlt)
library.add(faExclamationTriangle)
library.add(faSpinner)
library.add(faTimesCircle)
library.add(faSms)
library.add(faTabletAlt)
library.add(faFileAlt)
library.add(faQrcode)
library.add(faFileInvoiceDollar)
library.add(faAddressCard)
library.add(faExclamationCircle)
library.add(faFilter)
library.add(faLaptopMedical)
library.add(faMicrophoneAlt)
library.add(faMicrophoneAltSlash)
library.add(faCircle)
library.add(faCheckCircle)
library.add(faExternalLink)
library.add(faMortarPestle)
library.add(faHandHoldingMedical)
library.add(faPrescriptionBottle)
library.add(faAllergies)
library.add(faScalpelPath)
library.add(faVideo)
library.add(faVideoSlash)
library.add(faBooksMedical)
library.add(faPortrait)
library.add(faSlash)
library.add(faEnvelope)
library.add(faCreditCardFront)
library.add(faMoneyCheckAlt)
library.add(faClipboardMedical)
library.add(faMessageDollar)
library.add(faBuildingColumns)
library.add(faHospital)
library.add(faCheckDouble)
library.add(faBellSlash)
library.add(faSquareArrowUpRight)
library.add(faNote)
library.add(faListUl)
library.add(faPen)
library.add(faCircleInfo)
library.add(faCreditCard)
library.add(faCommentSms)
library.add(faUserDoctor)
library.add(faLocationDot)
library.add(faBarsProgress)
library.add(faNotesMedical)
library.add(faCaretUp)
library.add(faCaretDown)
library.add(faChartNetwork)
library.add(faShieldCheck)
library.add(faHospitalUser)
library.add(faUpload)
library.add(faBoxArchive)
library.add(faCalendarCircleUser)
library.add(faFileUpload)
library.add(faFolderArrowDown)
library.add(faMoneyCheckDollar)
library.add(faClipboardListCheck)

const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
}

Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0)

Vue.use(VueLogger, options)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
Vue.use(BootstrapVue)
Vue.use(vClickOutside)

Vue.use(VueMatomo, {
  // Configure your matomo server and site by providing
  host: process.env.VUE_APP_ANALYTICS_BASE_URL,
  siteId: process.env.VUE_APP_ANALYTICS_SITE_ID,

  // Changes the default .js and .php endpoint's filename
  // Default: 'piwik'
  trackerFileName: 'matomo',

  // Overrides the autogenerated tracker endpoint entirely
  // Default: undefined
  // trackerUrl: 'https://example.com/whatever/endpoint/you/have',

  // Enables automatically registering pageviews on the router
  router,

  // Enables link tracking on regular links. Note that this won't
  // work for routing links (ie. internal Vue router links)
  // Default: true
  enableLinkTracking: true,

  // Require consent before sending tracking information to matomo
  // Default: false
  requireConsent: false,

  // Whether to track the initial page view
  // Default: true
  trackInitialView: true,

  // Whether or not to log debug information
  // Default: false
  debug: true
})

Vue.config.warnHandler = function (msg, vm, trace) {
  const errorMessage = `Warn: ${msg}\nTrace: ${trace}`
  if (Vue.prototype.$matomo) {
    Vue.prototype.$matomo.trackEvent('WarnHandler', 'Error', errorMessage)
  }
  console.warn(errorMessage)
}

Vue.config.errorHandler = function (err, vm, info) {
  const errorMessage = `Error: ${err.toString()}\nInfo: ${info}`
  if (Vue.prototype.$matomo) {
    Vue.prototype.$matomo.trackEvent('ErrorHandler', 'Error', errorMessage)
  }
  console.error(errorMessage)
}

Vue.config.productionTip = false
Vue.$log.debug('Base API Url: ' + process.env.VUE_APP_API_BASE_URL)

store.restoreSession()

Object.defineProperties(Vue.prototype, {
  $store: {
    get: function () {
      return store
    }
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
